import StepProgressBar from '@/components/charts/step-progress-bar/step-progress-bar';
import MCIcon from '@/components/icons/mc-icon/mc-icon';
import { MarkerDataModel } from '@/models/marker/marker';
import { LearnerPreference } from '@/models/proficiency/learner-preference';
import { scoreValidation } from '@/utils/utils';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import DependentCompetencies from '../dependent-competencies/dependent-competencies';

@Component({
    name: 'learner-identity',
    components: {
        'step-progress-bar': StepProgressBar,
        'mc-ion': MCIcon,
        'dependent-competency-panel': DependentCompetencies,
    },
})

export default class LearnerIdentityComponent extends Vue {

    // ------------------------------------------------
    // Properties

    @Prop({default: []})
    private dependentCompetencies: any;

    @Prop()
    private learnerPreferences!: LearnerPreference[];

    @Prop()
    private dokContent: any ;

    @Prop()
    private showcaseCompetency: any;

    @Prop()
    private showcaseData!: MarkerDataModel;

    @Prop()
    private primaryCompetency!: any;

    private masteryStatus: any = [
        {
            label: 'Inprogress',
            value: 1,
        },
        {
            label: 'Mastered',
            value: 4,
        },
        {
            label: 'Not Started',
            value: 0,
        },
    ];

    @Watch('learnerPreferences', {deep: true})
    private onWatchPreference() {
        const learnerPreferences = this.learnerPreferences;
        const { learner } = this.showcaseData;
        learnerPreferences.forEach((item: any) => {
            learner.resourcePref[item.keyName] = parseFloat(item.value);
        });
    }

    // ------------------------------------------------
    // Actions

    private onEditDependent(dependent: any) {
        this.$emit('onEditDependent', dependent);
    }


    private onChangeConfidence(event: any) {
        scoreValidation(event, 1);
    }




}
